import { cn } from "@/lib/utils";

export function TaxChips({ rules, value, onChange, testId }) {
  const active = (rules || []).filter((r) => r.active);
  if (!active.length) return <span className="text-xs text-slate-400">No taxes configured</span>;
  return (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {active.map((r) => {
        const on = value.includes(r.code);
        return (
          <button key={r.code} type="button" data-testid={`${testId}-${r.code}`} onClick={() => onChange(on ? value.filter((c) => c !== r.code) : [...value, r.code])}
            className={cn("rounded-full border px-2 py-0.5 text-[11px] font-medium transition-colors", on ? "border-[#13294B] bg-[#13294B] text-white" : "border-slate-200 text-slate-500 hover:border-slate-300")}>
            {r.code} {r.rate}%</button>
        );
      })}
    </div>
  );
}

export function TaxTotals({ calc, currency, fmt }) {
  return (
    <dl className="ml-auto w-full max-w-xs space-y-1 text-sm" data-testid="tax-totals">
      <div className="flex justify-between"><dt className="text-slate-500">Subtotal</dt><dd className="tabular-nums">{fmt(calc.subtotal, currency)}</dd></div>
      {calc.breakdown.map((b) => (
        <div key={b.code} className="flex justify-between"><dt className="text-slate-500">{b.kind === "withholding" ? "Less " : ""}{b.name} ({b.rate}%)</dt>
          <dd className="tabular-nums">{b.kind === "withholding" ? "−" : ""}{fmt(b.amount, currency)}</dd></div>))}
      <div className="flex justify-between border-t border-slate-200 pt-1 font-semibold"><dt>Total due</dt><dd className="tabular-nums" data-testid="tax-totals-total">{fmt(calc.total, currency)}</dd></div>
    </dl>
  );
}
